import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import { Link } from "react-router-dom";
import { get_platform_banners } from "../store/reducers/homeReducer";
import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

const Banner = () => {
  const dispatch = useDispatch();
  const { platformBanners } = useSelector((state) => state.home);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 1,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 1,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 1,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  useEffect(() => {
    dispatch(get_platform_banners());
  }, [dispatch]);



  return (
    <div className="w-full">
      {platformBanners && platformBanners.length > 0 ? (
        <div className="w-[100%] lg:w-[100%] mx-auto br">
          <div className="w-full flex flex-wrap">
            <div className="w-full">
              <div className="w-full">
                <Carousel
                  autoPlay={true}
                  infinite={true}
                  arrows={false}
                  showDots={false}
                  responsive={responsive}
                >
                  {platformBanners.map((banner, index) => (
                    <div key={banner._id || index} className="lg-md:h-[440px] h-auto w-full block">
                      {banner.link ? (
                        <Link to={banner.link} className="block w-full h-full">
                          <img
                            className="nex_banner_img "
                            src={banner.image}
                            alt={banner.title || `Banner ${index + 1}`}
                      
                          />
                        </Link>
                      ) : (
                        <img
                          className="nex_banner_img "
                          src={banner.image}
                          alt={banner.title || `Banner ${index + 1}`}
                       
                        />
                      )}
                    </div>
                  ))}
                </Carousel>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default Banner;
